export const getFechaActual = () => {
    var date = new Date()
    return date
}

export const getFechaActualSinTiempo = () => {
    return getFechaSinTiempo(getFechaActual())
}

export const getFechaSinTiempo = (fecha) => {
    fecha.setHours(0, 0, 0, 0)
    return fecha
}

export const fechaMayorIgualQueFecha = (fecha1, fecha2) => {
    return fecha1 >= fecha2
}

export const fechaMenorIgualQueFecha = (fecha1, fecha2) => {
    return fecha1 <= fecha2
}

export const getMeses = () => {
    const stringMeses = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ]
    return stringMeses.map((mes, i) => ({numero: i + 1, nombre: mes}))
}

export const getAniosParaSeleccionar = () => {
    const anioInicioSoftware = 2019
    const anioActual = getFechaActual().getFullYear()
    const anios = []
    for (let i = anioInicioSoftware; i < anioActual + 5; i++) {
        anios.push(i)
    }
    return anios
}


export const toStringMesTextoFromFechaCompletoFromString = (fechaString) => {
    const fecha = getFechaFromString(fechaString)
    return (
        (fecha.getDate()) +
        ' de ' +
        getMonthString(fecha.getMonth()).toLowerCase() +
        ' ' +
        fecha.getFullYear()
    )
}


export const toStringMesTextoFromFecha = (fecha) => {
    return (
        (fecha.getDate()) +
        ' ' +
        getMonthStringMin(fecha.getMonth()) +
        ' ' +
        fecha.getFullYear()
    )
}

export const toStringMesTextoWithoutYear = (fecha) => {
    return (
        fecha.getDate() +
        ' ' +
        getMonthString(fecha.getMonth())
    )
}

export const toStringMesTextoPartialYear = (fecha) => {
    return (
        fecha.getDate() +
        ' ' +
        getMonthStringMin(fecha.getMonth()) +
        (new Date().getFullYear() === fecha.getFullYear()
            ? ''
            : '/' + fecha.getFullYear().toString().slice(-2))
    )
}

export const toStringDiaSemanaMes = (fecha) => {
    return (
        getDayStringMin(fecha.getDay()) +
        ', ' +
        fecha.getDate() +
        ' ' +
        getMonthStringMin(fecha.getMonth()) +
        (new Date().getFullYear() === fecha.getFullYear()
            ? ''
            : '/' + fecha.getFullYear().toString().slice(-2))
    )
}

export const toStringDiaSemanaMesFullYear = (fecha) => {
    return (
        getDayStringMin(fecha.getDay()) +
        ', ' +
        fecha.getDate() +
        ' ' +
        getMonthStringMin(fecha.getMonth()) +
        ' de ' +
        fecha.getFullYear().toString()
    )
}

export const getTipoDia = (fecha) => {
    return getDayStringMin(fecha.getDay())
}

export const toStringDate = (date) =>
    date.getFullYear() +
    '-' +
    (date.getMonth() + 1 >= 10
        ? date.getMonth() + 1
        : 0 + '' + (date.getMonth() + 1)) +
    '-' +
    (date.getDate() >= 10 ? date.getDate() : 0 + '' + date.getDate())

export const toStringTime = (date) =>
    (date.getHours() >= 10 ? date.getHours() : 0 + '' + date.getHours()) +
    ':' +
    (date.getMinutes() >= 10 ? date.getMinutes() : 0 + '' + date.getMinutes())

export const toStringDateTime = (date) =>
    toStringDate(date) + ' ' + toStringTime(date)

export const getMonthString = (month) => {
    const meses = []
    meses[0] = 'Enero'
    meses[1] = 'Febrero'
    meses[2] = 'Marzo'
    meses[3] = 'Abril'
    meses[4] = 'Mayo'
    meses[5] = 'Junio'
    meses[6] = 'Julio'
    meses[7] = 'Agosto'
    meses[8] = 'Septiembre'
    meses[9] = 'Octubre'
    meses[10] = 'Noviembre'
    meses[11] = 'Diciembre'
    return meses[month]
}

export const getMonthStringMin = (month) => {
    const meses = []
    meses[0] = 'Ene'
    meses[1] = 'Feb'
    meses[2] = 'Mar'
    meses[3] = 'Abr'
    meses[4] = 'May'
    meses[5] = 'Jun'
    meses[6] = 'Jul'
    meses[7] = 'Ago'
    meses[8] = 'Sep'
    meses[9] = 'Oct'
    meses[10] = 'Nov'
    meses[11] = 'Dic'
    return meses[month]
}

export const getDayStringMin = (dia) => {
    const dias = []
    dias[0] = 'Dom'
    dias[1] = 'Lun'
    dias[2] = 'Mar'
    dias[3] = 'Mie'
    dias[4] = 'Jue'
    dias[5] = 'Vie'
    dias[6] = 'Sab'
    return dias[dia]
}

export const getFechaStringNoTime = (fecha) => {
    return toStringDate(fecha)
}

export const getFechaStringActualNoTime = () => {
    return getFechaStringNoTime(new Date())
}

export const getTimeStringNoFecha = (fecha) => {
    return (
        (fecha.getHours() < 10 ? '0' + fecha.getHours() : fecha.getHours()) +
        ':' +
        (fecha.getMinutes() < 10 ? '0' + fecha.getMinutes() : fecha.getMinutes())
    )
}

export const getTimeStringActualNoFecha = () => {
    return getTimeStringNoFecha(new Date())
}

export var isSafari = navigator.userAgent.toLowerCase().indexOf('safari') !== -1

export const getDateFromFechaTime = (fecha, time) => {
    if (isSafari) {
        return new Date(`${fecha}T${time.length < 8 ? time + ':00' : time}-05:00`)
    } else {
        return new Date(`${fecha} ${time.length < 8 ? time + ':00' : time}`)
    }
}

export const addMinutos = (fecha, minutes) => {
    return new Date(fecha.getTime() + minutes * 60000)
}

export const addHoras = (fecha, horas) => {
    return addMinutos(fecha, horas * 60)
}

export const addDias = (fecha, dias) => {
    return addHoras(fecha, dias * 24)
}

export const toStringTimeAMPM = (time) => {
    if (time) {
        const H = +time.substr(0, 2)
        const h = H % 12 || 12
        const ampm = H < 12 || H === 24 ? ' AM' : ' PM'
        return h + time.substr(2, 3) + ampm
    } else return ''
}

export const generarAnios = () => {
    const date = new Date()
    const anios = []
    for (let i = -5; i < 5; i++) {
        anios.push(date.getFullYear() + i)
    }
    return anios
}

export const getMinutos = (date1, date2) => {
    const diff = Math.abs(date1 - date2);
    return Math.floor((diff / 1000) / 60);
}

export const getFechaFromString = (s) => {
    if (s) {
        return new Date(s.replace(/-/g, "/") + " 00:00")
    }
}
